import { render, staticRenderFns } from "./CourseReview.vue?vue&type=template&id=e83753a4"
import script from "./CourseReview.vue?vue&type=script&lang=js"
export * from "./CourseReview.vue?vue&type=script&lang=js"
import style0 from "./CourseReview.vue?vue&type=style&index=0&id=e83753a4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports